<form [formGroup]="myForm" class="d-flex gap-2">
  <mat-form-field class="" appearance="outline">
    <mat-label>Select State</mat-label>
    <input type="text" matInput formControlName="stateName" id="stateName" [matAutocomplete]="auto"
      aria-label="Select State" />
    @if (stateNameControl.value && !isStateReadonly()) {
    <button matSuffix matIconButton aria-label="Clear" (click)="resetFilter()" class="btn border-0">
      <i class="bi bi-x-lg"></i>
    </button>
    }
    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
      @for (state of filteredStates | async; track $index) {
      <mat-option [value]="state.name" (onSelectionChange)="onStateSelection(state)">{{ state.name }}</mat-option>
      } @if (noDataFound()) {
      <mat-option class="text-muted" disabled>No results found for your search.</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>